import React, { useMemo } from "react";

import { TelegramAuthProvider } from "@/store/TelegramAuthProvider";
import { WebAuthProvider } from "@/store/WebAuthProvider";
import { hasTelegramIdParam, isTelegramEnv } from "@/utils/helpers";

export const AuthProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const inTelegram = useMemo(() => isTelegramEnv(), []);
  const hasTelegramId = useMemo(() => hasTelegramIdParam(), []);

  if (inTelegram && !hasTelegramId) {
    return <TelegramAuthProvider>{children}</TelegramAuthProvider>;
  }

  return <WebAuthProvider>{children}</WebAuthProvider>;
};
